import { encryptPayload } from "../utility/encryption";
import { app } from "./serviceLMS";
export async function fetchUserEnrolledCourses(
  page = 0,
  size = 10
) {
  try {
    const params={page,size};
    const response = await app.get("user/api/client-api/users/userCourses",{
      params,
    });
    return response.data.data;
  } catch (error) {
    throw new Error(
      error?.response?.data?.message || "Failed to fetch enrolled courses."
    );
  }
}

// export async function fetchUserEnrolledCoursesById(userId) {
//   try {
//     const response = await app.get(
//       `user/api/client-api/enrollment/userCourses/${userId}`);
//       console.log("Response of fetchUserEnrolledCoursesById", response.data.data)
//     return response.data.data;
//   } catch (error) {
//     throw new Error(
//       error?.response?.data?.message || "Failed to fetch enrolled courses."
//     );
//   }
// }


// export async function fetchUserEnrolledCoursesWithoutId() {
//   try {
//     const response = await app.get(
//       `user/api/service-api/users/userCourses`);
//     return response.data.data;
//   } catch (error) {
//     throw new Error(
//       error?.response?.data?.message || "Failed to fetch enrolled courses."
//     );
//   }
// }


export async function fetchUserEnrolledCoursesWithoutId() {
  try {
    const response = await app.get(
      `user/api/client-api/users/userCourses`);
    return response.data;
  } catch (error) {
    throw new Error(
      error?.response?.data?.message || "Failed to fetch enrolled courses."
    );
  }
}

export async function fetchUserNameById(userId) {
  try {
    const response = await app.get(
      `user/api/client-api/users/${userId}`);

    const data = response.data;

    if (data.status === "SUCCESS" && data.data) {
      return `${data.data.firstName} ${data.data.lastName}`;
    }

    console.warn("No user found for ID:", userId);
    return null;
  } catch (error) {
    console.error(
      "Error fetching user name:",
      error.response?.data || error.message
    );
    return null;
  }
}

export async function fetchCourseDetails(courseId) {
  console.log("courseID", courseId)
  try {
    console.log("FetchCourseDetails fetching ......")
    const response = await app.get(
      `course/api/client-api/course/${courseId}`
    );
    console.log("FetchCourseDetails", response.data.data)
    console.log("response of fetchCourseDetails", response)
    return response.data.data;
  } catch (error) {
    throw new Error("Failed to fetch course details.");
  }
}

export async function getCourseProgressWithMeta(userId, courseId) {
  try {
    const response = await app.get(
      `course/api/client-api/user-progress/meta?userId=${userId}&courseId=${courseId}`
    );
    return response.data;
  } catch (error) {
    return 0;
  }
}


export async function getCourseProgressWithMetaCourseId(courseId) {
  try {
    const response = await app.get(
      `course/api/client-api/user-progress/meta-courseId?courseId=${courseId}`
    );
    return response.data;
  } catch (error) {
    return 0;
  }
}


// export async function getCourseProgressWithMetaCourseId(courseId) {
//   try {
//     const response = await app.get(
//       `course/api/service-api/user-progress/meta-courseId?courseId=${courseId}`
//     ); 
//     return response.data;
//   } catch (error) {
//     return 0;
//   }
// }

export async function getUserEnrolledCourseDetails(userId, page, size) {
  try {
    const newEnrollments = await fetchUserEnrolledCourses(page, size);

    const enrollments = Array.isArray(newEnrollments?.content) ? newEnrollments.content : [];
    const totalElements = newEnrollments?.totalElements ?? enrollments.length;

    if (enrollments.length === 0) {
      throw new Error("Couldn't retrieve enrollments");
    }

    const allCoursesCount = enrollments.length;

    const courseDetailsPromises = enrollments.map(async (enrollment, index) => {
      const courseDetails = await fetchCourseDetails(enrollment.courseId);

      let progressMeta = null;
      if (userId) {
        progressMeta = await getCourseProgressWithMeta(userId, enrollment.courseId);
      } else {
        progressMeta = await getCourseProgressWithMetaCourseId(enrollment.courseId);
      }

      if (!progressMeta) {
        throw new Error("Couldn't fetch course metadata");
      }

      const completionPercentage = progressMeta.courseCompletionPercentage;
      const firstCompletedAt = progressMeta.firstCompletedAt;
      const roundedCompletion = parseFloat(completionPercentage.toFixed(2));

      const todayISO = new Date().toISOString().split("T")[0];
      const deadlineISO = enrollment.deadline
        ? new Date(enrollment.deadline).toISOString().split("T")[0]
        : null;

      let status = "Not Started";
      let adherence = "N/A";

      if (roundedCompletion >= 95.0) {
        if (firstCompletedAt) {
          const completedISO = new Date(firstCompletedAt).toISOString().split("T")[0];
          if (!deadlineISO) {
            status = "Completed";
            adherence = "No Deadline";
          } else if (completedISO <= deadlineISO) {
            status = "Completed";
            adherence = "On Time";
          } else {
            status = "Completed";
            adherence = "Late";
          }
        } else {
          status = "Completed";
          adherence = deadlineISO ? "Late" : "No Deadline";
        }
      } else if (roundedCompletion > 0) {
        status = deadlineISO && todayISO > deadlineISO ? "Completion Failed" : "In Progress";
        adherence = deadlineISO
          ? todayISO <= deadlineISO
            ? "Ongoing On Time"
            : "Ongoing Late"
          : "No Deadline";
      } else {
        status = deadlineISO && todayISO > deadlineISO ? "Completion Failed" : "Not Started";
        adherence = deadlineISO
          ? todayISO <= deadlineISO
            ? "On Time (Yet to Start)"
            : "Late (Yet to Start)"
          : "No Deadline";
      }

      let assignedByName = "Unknown";
      if (enrollment.assignedById) {
        const name = await fetchUserNameById(enrollment.assignedById);
        assignedByName = name || "Unknown";
      }

      return {
        ...courseDetails,
        assignedById: assignedByName,
        enrollmentDate: enrollment.enrollmentDate,
        deadline: enrollment.deadline,
        roundedCompletion,
        status,
        adherence,
        allCoursesCount,
      };
    });

    const processedCourses = await Promise.all(courseDetailsPromises);

    return {
      content: processedCourses,
      totalElements,
    };
  } catch (error) {
    throw new Error("Failed to retrieve user enrolled courses. " + error.message);
  }
}

export async function fetchContentProgress(userId, courseId, contentId) {
  try {
    const response = await app.get(
      `course/api/client-api/user-progress/content?userId=${userId}&courseId=${courseId}&contentId=${contentId}`
    );
    // console.log(response.data);
    return response.data;
  } catch (error) {
    return 0;
  }
}

export async function fetchContentAcknowledgement(userId, courseId, contentId) {
  try {
    const response = await app.get(
      `course/api/client-api/user-progress/get-acknowledgement?userId=${userId}&courseId=${courseId}&contentId=${contentId}`
    );
    console.log(response.data);
    return response.data.data;
  } catch (error) {
    return 0;
  }
}


export async function 
updateContentProgress(
  userId,
  contentId,
  courseId,
  lastPosition,
  newCompletionPercentage,
  contentType
) {
  try {
    const existingCompletionPercentage = await fetchContentProgress(
      userId,
      courseId,
      contentId
    );
    const finalCompletionPercentage = Math.max(
      existingCompletionPercentage,
      newCompletionPercentage
    );

    const rawPayload = {
      userId,
      contentId,
      courseId,
      contentLastPosition:lastPosition,
      lastUpdated: new Date().toISOString(),
      contentCompletionPercentage: finalCompletionPercentage,
      courseContentType:contentType,
    };

    const encryptedString = await encryptPayload(rawPayload);
    const encryptedPayload = { payload: encryptedString };

    await app.post(
      `course/api/client-api/user-progress/update`,
      encryptedPayload
    );

    console.log(`Content progress updated successfully`);
  } catch (error) {
    console.error(
      "Error updating content progress:",
      error.response?.data || error.message
    );
  }
}

export async function markContentAsCompleted(courseId, contentId, userId) {
  try {
    console.log("Marking content as completed for user:", userId, "course:", courseId, "content:", contentId);
    const response = await app.post(`course/api/client-api/user-progress/acknowledge-content?userId=${userId}&courseId=${courseId}&contentId=${contentId}`);
    console.log("Content marked as completed response:", response);

    return response.data;
  } catch (error) {
    console.error("Error marking content as completed:", error);
    throw error;
  }
}
export async function getUserEnrolledCourses({ page, pageSize, search }) {
  const params = new URLSearchParams();

  if (page != null) params.append("page", page);
  if (pageSize != null) params.append("size", pageSize);
  if(search != null) params.append("searchText", search);

  const endpoint = `user/api/client-api/users/user-courses${
    params.toString() ? `?${params.toString()}` : ""
  }`;

  try {
    const { data } = await app.get(endpoint);
    return { success: true, data };
  } catch (error) {
    console.error(error);
    return {
      success: false,
      message: error.response?.data?.message || "Request failed",
    };
  }
}

